import React, { useState } from 'react';
import { Sample, getSamplesByID } from 'utils/SamplesUtil';
import { useAppContext } from 'hooks/useAppContext';
import SampleTab from './SampleTabs'
import { Badge, makeStyles, Paper, useTheme } from '@material-ui/core';
import { Card, CardContent } from '@material-ui/core';
import StatusStepper from './StatusStepper'
import withAppStylesGrid from 'HOCs/withAppStyles';
import MaterialTable from 'material-table';
import { AttachFile } from '@material-ui/icons';
import withInspectionLink from 'HOCs/withInspectionLink';

export default function SampleDetailsGrid({ sampleID }) {
    const { selectedProject } = useAppContext(); //Getting the App Context
    const [sample, setSample] = useState({});
    const [status, setStatus] = useState(0);
    const theme = useTheme();

    const columns = Sample.columns;
    const title = "Project Samples"
    const useStyles = makeStyles((theme) => ({
        spacer: {
            "background": theme.palette.primary.default,
            "color": theme.palette.primary.contrastText,
            "minHeight": "50px"
        }
    }));

    const classes = useStyles();

    const updateStepper = (active) => {
        setStatus(active ? 3 : 2)
    };

    const getRecords = React.useCallback(async (page, pageSize, orderBy, orderDirection, _search, _filters) => {
        const getSampleData = (_sample) => {
            if (_sample[0].BaseSampleId !== sample.BaseSampleId) {
                setSample(_sample[0])
                setStatus(_sample[0].SampleDeliveryLogs[0].PassFail ? 3 : 2)
            }
        };
        const r = await getSamplesByID(page, pageSize, orderBy, orderDirection, { SAMPLE_CD: sampleID }, _filters);
        getSampleData(r.data)
        return {
            data: r.data,
            count: r.count
        }
    }, [sample.BaseSampleId, sampleID]);

    const GridWithAppStyles = withInspectionLink(
            withAppStylesGrid(MaterialTable, { theme, getRecords: getRecords, defaultFilters: { projectId: selectedProject } }),
        { inspectionColumnTitle: "Inspection #" });

    return (
        <div>
            <Paper style={{ borderRadius: 4, margin: 4 }}>
                <StatusStepper currentStatus={status} />
                <Card style={{ borderRadius: 0, boxShadow: "0 0 transparent" }}>
                    <CardContent>
                        {/* <Grid columns={columns} title={title} getRecords={getSamplesByID} selectedProject={selectedProject} component="Samples" formPath={getFormPath} selection={search} paging={false} /> */}
                        <GridWithAppStyles
                            columns={columns.map(col => {
                                if (col.title === "Attachments") {
                                    col.render = (rowData) => (<Badge badgeContent={rowData[col.field].length} color="secondary" showZero><AttachFile></AttachFile></Badge>)
                                    col.cellStyle = { textAlign: 'left' }
                                }
                                return col

                            }).filter(r => !r.hide)}
                            title={title}
                            options={
                                { paging: false, toolbar: false }
                            }
                        />
                    </CardContent>
                </Card>
            </Paper>
            <div className={classes.spacer} />
            <SampleTab sample={sample} callback={updateStepper} />
        </div>
    )
}